import type { TimelineEvent } from "@/types/content";
import StatusBadge from "@/components/base/StatusBadge";

export default function TimelineItem({
  event,
  index,
}: {
  event: TimelineEvent;
  index: number;
}) {
  return (
    <li className="relative flex gap-4 pb-8 last:pb-0 md:gap-6">
      <div className="flex flex-col items-center">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-primary-200 bg-primary-100 font-heading text-xs font-bold text-primary-700">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="mt-2 w-px flex-1 bg-background-300"></span>
      </div>

      <article className="flex-1 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
          <span className="font-heading text-sm font-bold text-foreground-950">
            {event.date}
          </span>
          <span className="whitespace-nowrap rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
            {event.time}
          </span>
          <StatusBadge status={event.status} size="sm" />
        </div>

        <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
          {event.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
          {event.summary}
        </p>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          {event.detail}
        </p>

        <div className="mt-4 border-t border-background-200 pt-3">
          <p className="text-[11px] font-medium tracking-wide text-foreground-500">
            本条来源
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            {event.sources.map((source) => (
              <span
                key={source}
                className="inline-flex items-center gap-1 whitespace-nowrap rounded border border-background-300 bg-background-100 px-2 py-1 text-[11px] text-foreground-600"
              >
                <span className="flex h-3 w-3 items-center justify-center">
                  <i className="ri-links-line text-xs"></i>
                </span>
                {source}
              </span>
            ))}
          </div>
        </div>
      </article>
    </li>
  );
}